import { QueryList } from '@angular/core';
import { UiCardComponent } from '../card';
import * as i0 from "@angular/core";
const _c0 = ["*"];
/**
 * center content elements vertically and horizontally.
 * Does NOT justify texts in center!
 */
export let UiContentCenteredComponent = /*#__PURE__*/(() => {
  class UiContentCenteredComponent {
    constructor() {
      this.hasCard = false;
      this.padding = true;
      this.vCenter = false;
    }
    get csSmall() {
      return this.cardSize === 'small';
    }
    get csMedium() {
      return this.cardSize === 'medium';
    }
    get csBlock() {
      return this.cardSize === 'block';
    }
    // immediate children of type Card
    set cards(cards) {
      // console.log()
      this.hasCard = cards.length > 0;
      if (this.hasCard) this.cardSize = cards.first.size;
    }
    static {
      this.ɵfac = function UiContentCenteredComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiContentCenteredComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiContentCenteredComponent,
        selectors: [["ui-content-centered"]],
        contentQueries: function UiContentCenteredComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiCardComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cards = _t);
          }
        },
        hostVars: 12,
        hostBindings: function UiContentCenteredComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("has-card", ctx.hasCard)("padded", ctx.padding)("v-center", ctx.vCenter)("card-size-small", ctx.csSmall)("card-size-medium", ctx.csMedium)("card-size-block", ctx.csBlock);
          }
        },
        inputs: {
          padding: "padding",
          vCenter: "vCenter"
        },
        ngContentSelectors: _c0,
        decls: 1,
        vars: 0,
        template: function UiContentCenteredComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:flex;min-height:min-content;height:100%;padding:10px}.v-center[_nghost-%COMP%]{align-items:center}[_nghost-%COMP%]{width:100%}[_nghost-%COMP%] >   *{margin:auto;flex-wrap:wrap}.padding[_nghost-%COMP%]{padding:40px 0}@media (max-width: 399px){.has-card.card-size-small[_nghost-%COMP%]{display:block;padding:0}}@media (max-width: 839px){.has-card.card-size-medium[_nghost-%COMP%]{display:block;padding:0}}@media (max-width: 1199px){.has-card.card-size-block[_nghost-%COMP%]{display:block;padding:0}}"],
        changeDetection: 0
      });
    }
  }
  return UiContentCenteredComponent;
})();